/* eslint-disable prettier/prettier */
import { t } from '~/helpers/localization';

t('%(player)s заблокирован до %(date)s %(time)s');
t('... еще ');
t('Бои в Операциях');
t('В статистике клана не учитывается скрытая статистика игрока, если только он один скрыл свою статистику в этом клане.:текст тултипа статистика клана строка 3',);
t('Все игроки клана с допуском получают дополнительно %(extraExpPercent)s опыта за бой на кораблях нации: %(nation)s.');
t('Вызвать контекстное меню');
t('Выполните все задачи клана')
t('Допуск получен');
t('Если в клане только один игрок, и он скрыл свою статистику, то статистика этого клана тоже будет скрыта.:текст тултипа статистика клана строка 4',);
t('Задачи для получения звезд')
t('Заявка на вступление');
t('Заявка уже отклонена');
t('Игровые дни');
t('Игровые предпочтения клана');
t('Измените цвет');
t('Клан с таким названием уже зарегистрирован');
t('Клан с таким тегом уже зарегистрирован.');
t('Клановые бои');
t('Когда статистика игрока скрыта, количество добытых им баррелей нефти остаётся доступным для просмотра командующему и заместителям командующего.:текст тултипа статистика клана строка 2',);
t('Корпус построен:notification_header');
t('Максимальное количество игроков в клане увеличилось на %(members)s.');
t('Набрав определенное количество звёзд, каждый получит награду');
t('Награды');
t('Нажмите, чтобы открыть описание клана:tooltip');
t('Не удалось получить данные о количестве баррелей нефти:tooltip');
t('Недостаточно полномочий');
t('Недостаточно средств');
t('Неправильный формат');
t('Операции');
t('Получайте звезды и соотвествующие награды.')
t('Получение звезд');
t('При наличии корпусов, вы можете получать дополнительно %(extraExpPercent)s опыта за бой, покупать исследуемые корабли по сниженной на %(costValuePercent)s стоимости и проводить их обслуживание по сниженной на %(maintenanceValuePercent)s стоимости.',);
t('Распределение ресурсов');
t('Ростральная колонна построена:notification_header');
t('Ростральная колонна символизирует успех и достижения вашего клана.');
t('Случайные бои в отряде');
t('Среднее количество звезд');
t('Средний уровень кораблей');
t('Становится доступной после выполения задачи');
t('Статистика клана');
t('Статистические показатели клана расcчитываются как среднее арифметическое показателей игроков клана.:текст тултипа статистика клана строка 1',);
t('Стоимость')
t('Стоимость исследуемых кораблей %(level)s уровня снижена на %(costValuePercent)s для всех игроков клана с допуском.');
t('Стоимость обслуживания кораблей класса %(shipClass)s снижена на %(maintenanceValuePercent)s для всех игроков клана с допуском.');
t('Техническая ошибка');
t('Транзакция прошла успешно!');
t('Цвет слишком светлый');
t('Цвет слишком тёмный');
t('Чтобы получить звёзды, вам необходимо выполнять  %(task)s в составе отряда со следующими участниками клана:');
t('Это строение уже возведено');
t('определенные задачи')

// Old Supply Promo on search page
t('А с помощью клана вы можете заработать их существенно больше, приняв участие в клановых боях или построив определенные здания в Военно-Морской базе.',)
t('В World of Warships есть различные ресурсы, которые можно обменять на уникальное или просто полезное имущество.',)
t('В игре Мир кораблей есть различные ресурсы, которые можно обменять на уникальное или просто полезное имущество.',)
t('Дополнительный опыт для командира, а также увеличенная добыча стали и угля.')
t('Еще больше бонусов!')
t('Здания теперь компактно отображены справа и вы легко сможете следить за состоянием базы.')
t('На вкладке «Состав клана» вы можете посмотреть не только имена и должности всех соклановцев, но также их статистику по каждому типу боя и количество заработанной нефти.',)
t('Нефть')
t('Новые здания, новые возможности!')
t('Обновленная клановая база')
t('С друзьями к победе')
t('Сталь')
t('Уголь')
t('Хотите быть в курсе достижений товарищей по клану?')
t('клановый ресурс для постройки зданий в Военно-Морской базе. Зарабатывается при получении контейнеров, а также за некоторые боевые задачи',)
t('персональный ресурс, который обменивается на большинство товаров в Арсенале. Его можно получить из контейнеров, а также за различные боевые задачи',)
t('персональный ресурс, который обменивается на некоторые корабли в Арсенале, а также может быть конвертирован в значительное количество угля. Его можно получить в клановых и ранговых боях, а также в суперконтейнерах.')

// Old Recommendations Promo on search page
t('Изменить параметры подбора')
t('Мои предпочтения')
t('Подбор клана')
t('Рекомендательная система')
t('Тогда смело нажимайте кнопку "хочу в клан" и вам подберут несколько наиболее подходящих вам кланов, на основе ваших игровых предпочтений и личной статистики.')
t('Хотите вступить в клан, который регулярно участвует в клановых боях или просто найти товарищей для отрядной игры?',)
t('Хочу в клан')


// Old About Promo on search page
t('Активные бонусы вашего клана')
t('Зачем нужен клан?')
t('Играйте в клане, получайте ресурсы и обменивайте их на уникальные корабли и другое полезное имущество!')
t('Командная игра')
t('О клановой базе')
t('Просто играйте в ваши любимые типы боя и получайте дополнительный опыт за бой, скидки на прокачиваемые корабли и многие другие бонусы!',)
t('С помощью клана вы не только найдете себе товарищей для игры в отряде, но и получите доступ к особому типу боя ― Клановые бои.',)
t('Скидки и бонусы')
t('Уникальные награды')

// Old ClanRec Slides
t('Отправить заявку:clanrec')
t('Клан подходит вам на')
t('Количество игроков')
t('Список наиболее подходящих кланов формируется в зависимости от вашей активности и выбранных предпочтений.')

// Errors
t('Invalid link.')

// Old ClanStars
t('Играйте в отряде')
t('Всего получено:')
t('Создавайте отряды')
t('Создавайте отряды и играйте с друзьями из клана')
t('Для получения звезд необходимо побеждать в составе отряда с друзьями из клана. Пригласите больше игроков в клан.')


// Onboarding - guidingtip
t('О «Звезде отряда»')

// Old clan color related strings
t('Не удалось изменить цвет тега:notification_header')
t('Цвет тега клана изменён:notification_header')
t('Цвет тега клана изменён')

// Old brawls description
t('В режиме "Клановый блиц" вы можете сразиться с кланами из других регионов.')
t('За высокие места в итоговом рейтинге кланы получают награды в клановую казну.')
t('Итоговое место клана в рейтинге определяется только количеством побед.')
t('Клановый блиц — это сражения, которые проводятся в рамках одного дня.')
t('Клановый блиц')
t('Побеждая в боях, вы получите различные награды.')

// Old Tooltip
t('Уровень клана: %(clanLevel)s', { clanLevel: 1 })
t('Чтобы пользоваться клановыми бонусами, необходимо заработать %(resource)s')
t('Без полномочий.:описание прав кадрового офицера в тултипе')
t('Заработанные награды поступают в казну клана.')
t('Заявка отправлена %(date)s&amp;nbsp;в&amp;nbsp;%(time)s.')
t('%(statusChanger)s одобрил заявку %(date)s&nbsp;в&nbsp;%(time)s')
t('%(statusChanger)s отклонил заявку %(date)s&nbsp;в&nbsp;%(time)s')

// Recruitment
t('Заявка уже отправлена')
t('Аккаунт игрока заблокирован до %(date)s&nbsp;%(time)s')

// Treasury Transaction Statuses
t('Распределение ресурсов прошло частично')
t('Операция выполнена частично')

// Wallet
t('Клановый ресурс')

// Nav
t('Задачи клана')
t('Состав клана')
t('Поиск клана')
t('Военная база')
t('Создать клан')
t('Казна клана')

// Search
t('Если ваши игровые предпочтения изменились или вы просто хотите сменить клан, воспользуйтесь рекомендательной системой и подберите себе новый клан.')

export const CURRENCY_DESCRIPTION: Record<string, string> = {
  'clan_resource': t(
    'Oil can be earned by participating in Clan Battles and various other activities. Every time a Clanmate earns any container, 10 Oil is added to the Treasury.\n\nThe Clan Commander and Deputy Commander can spend Oil on erecting structures in the Clan Base and obtaining bundles in the Treasury.',
  ),
  'gold': t(
    'Doubloons can be earned as a reward for participating in various events.\nThe Clan Commander and Deputy Commander can allocate the resource among Clanmates.\n\nYou can spend Doubloons on Special and Premium ships, as well as other items in the Armory.',
  ),
  'coal': t(
    'Coal can be earned as a reward for winning Clan Battles, as well as for participating in various activities.\nThe Clan Commander and Deputy Commander can allocate the resource among Clanmates.\n\nYou can spend Coal on Special and Premium ships in the Armory.',
  ),
  'steel': t(
    'Steel can be earned as a reward for winning Clan Battles, as well as for participating in various activities.\nThe Clan Commander and Deputy Commander can allocate the resource among Clanmates.\n\nYou can spend Steel on Tier IX and X Special and Premium ships in the Armory.',
  ),
};